import { React, useEffect, useState } from "react";
import img_pajaro_verde from "../../../assets/images/img_pajaro_verde.png";
import ico_especies_emblematicas from "../../../assets/icons/ico_especies_emblematicas.svg";
import GoToPage from "../../../components/goToPage";
import img_fondo_especies_emblematicas from "../../../assets/images/img_fondo_especies_emblematicas.jpg";
const FlagShipSpecies = ({ handle }) => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    handle(false);
    return () => handle(true);
  }, [handle]);

  return (
    <div className="">
      {width > 1300 ? (
        <div>
          <div className="h-full w-full absolute overflow-hidden">
            <img
            loading="lazy"
              src={img_fondo_especies_emblematicas}
              className=" object-cover absolute w-full 2xl:h-screen xl:h-screen lg:h-[1100px]  md:h-[1100px] sm:h-[1080px] h-[1080px]"
            ></img>
          </div>
          <div className="grid lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 gap-0 w-full h-screen relative overflow-hidden">
            <div className="relative "></div>
            <div className="relative w-full h-full z-50 pt-10 ml-32">
              <div className="z-50 xl:ml-20 lg:ml-20 md:ml-20 sm:ml-20 ml-20 2xl:mt-0 xl:mt-10 lg:mt-20 mt-20">
                <GoToPage
                  page="/especies"
                  side="left"
                  name="Atrás"
                  fontsize="text-lg"
                  textColor="text-white"
                  borderType="border-b-2"
                  borderColor="border-white"
                  iconSize="h-4"
                  iconColor="invert"
                  iconMargin="mr-5"
                ></GoToPage>
              </div>
              <div className=" bg-white xl:ml-20 lg:ml-20 md:ml-20 sm:ml-20  ml-20 mr-52 h-full pt-14 mt-10 relative ">
                <div className=" absolute px-10 ">
                  <img
                  loading="lazy"
                    src={ico_especies_emblematicas}
                    className="xl:w-[5rem] lg:w-[10rem md:w-[5rem] sm:w-[5rem] w-[5rem]"
                  ></img>
                  <h1 className="2xl:text-7xl xl:text-5xl lg:text-3xl md:text-3xl sm:text-3xl tex-3xl font-bold">
                    Especies <br /> Emblemáticas
                  </h1>
                  <p className="mt-5 2xl:text-base xl:text-sm  lg:text-xs md:text-sm sm:text-sm text-sm">
                    Las especies emblemáticas son también conocidas como especie{" "}
                   bandera, ya que llaman la atención del público y se
                    utilizan para generar interés en la conservación de
                    un determinado lugar.{" "}
                  </p>
                  <p className="mt-5 2xl:text-base xl:text-sm  lg:text-xs md:text-sm sm:text-sm text-sm">
                  Por ejemplo, el quetzal (Pharomachrus mocinno) es un ave emblemática para la conservación de los bosques nublados de Centroamérica.
                  </p>
                </div>
              </div>
              <img
              loading="lazy"
                src={img_pajaro_verde}
                className="absolute 2xl:w-[50rem] xl:w-[40rem] lg:w-[30rem] md:w-[30rem] sm:w-[30rem] w-[30rem] pl-52 bottom-0 right-0 2xl:visible xl:invisible lg:invisible md:invisible sm:invisible invisible"
              ></img>
            </div>
          </div>
        </div>
      ) : (
        <div className="min-h-[100vh] grid grid-cols-1 grid-rows-2 ">
          <div className="relative overflow-hidden">
            <img
            loading="lazy"
              src={img_fondo_especies_emblematicas}
              className=" object-fill absolute w-full pt-10 bg-black -right-24 scale-150"
            ></img>
            <div className="z-50 xl:ml-0 lg:ml-20 md:ml-20 sm:ml-14 ml-14 absolute lg:mt-52 md:mt-44 sm:mt-32 mt-40">
              <GoToPage
                page="/especies"
                side="left"
                name="Atrás"
                fontsize="text-lg"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-4"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
            </div>
          </div>
          <div className=" bg-white xl:ml-0 lg:mt-32 md:mt-20 sm:mt-20 mt-20  h-fit pt-14  relative pb-10 ">
            <div className="flex justify-center items-center">
              <img
              loading="lazy"
                src={ico_especies_emblematicas}
                className="xl:w-[5rem] lg:w-[10rem md:w-[5rem] sm:w-[5rem] w-[5rem]"
              ></img>
            </div>

            <h1 className="2xl:text-7xl xl:text-6xl lg:text-6xl md:text-6xl sm:text-5xl text-5xl text-center font-bold">
              Especies <br /> Emblemáticas
            </h1>
            <p className="p-5 mt-5 lg:text-base md:text-sm sm:text-sm text-sm flex justify-center items-center">
              Las especies emblemáticas son también conocidas como especie{" "}
               bandera, ya que llaman la atención del público y se
              utilizan para generar interés en la conservación de un
              determinado lugar.{" "}
            </p>
            <p className="p-5 mt-5 lg:text-base md:text-sm sm:text-sm text-sm flex justify-center items-center">
            Por ejemplo, el quetzal (Pharomachrus mocinno) es un ave emblemática para la conservación de los bosques nublados de Centroamérica.
            </p>
          </div>
          <div className=" relative bg-slate-900 mt-40">
            <img
            loading="lazy"
              src={img_pajaro_verde}
              className=" absolute lg:w-[25rem] md:w-[23rem] sm:w-[20rem] w-[20rem] pl-5 bottom-0 right-0"
            ></img>
          </div>
        </div>
      )}
    </div>
  );
};

export default FlagShipSpecies;
